import type { OfficeLabels } from '..';

export const suraOfficeLabels: OfficeLabels = {
  label: 'test-sura',
  positionAccount: 'Pólizas',
  ebr: 'Riesgo',
};
